import { MARKERS } from './arrow';

/** One hidden SVG holding all arrowheads; referenced by id from edges (document-wide url(#…)). */
export function MarkerDefs() {
  return (
    <svg style={{ position: 'absolute', width: 0, height: 0 }} aria-hidden>
      <defs>
        {MARKERS.map(([id, color]) => (
          <marker
            key={id}
            id={`ol-arrow-${id}`}
            markerWidth={8}
            markerHeight={8}
            refX={6.5}
            refY={4}
            orient="auto"
            markerUnits="userSpaceOnUse"
          >
            <path d="M0,0 L8,4 L0,8 z" fill={color} />
          </marker>
        ))}
      </defs>
    </svg>
  );
}
